<!-- 获取用户信息 -->
<template>
  <div class="headerPage">
    <div class="header">
      <van-icon name="arrow-left" class="arrow_left" alt="" @click="goBack" />
      <span>领取优惠券</span>
      <div style="width:21px"></div>
    </div>
    <div class="top">
      <img src="@/assets/couponTop.png" alt="">
    </div>
    <van-loading v-if="loading" style="text-align: center;margin-top:50px;" type="spinner" />
    <div v-else>
      <div v-if="!msg ">
        <div :style="uid_show? '':'margin-bottom: 25px;'" class="coupon_box">
          <img src="@/assets/coupon.png" alt="">
          <div class="coupon_left">
            <div>
              <p v-if="couponInfo.discount_radio" style="marginBottom:8px">
                <span class="num">{{ couponInfo.discount_radio_name.slice(0,couponInfo.discount_radio_name.length-1) }}</span>
                <span class="danwei">折</span>
              </p>
              <p v-else style="marginBottom:2px">
                <span class="num">{{ couponInfo.money }}</span><span class="danwei">元</span>
              </p>
              <!-- <p v-else class="top">¥ <span class="number">{{ couponInfo.money }}</span></p> -->
              <p style="font-family: PingFangSC-Medium;font-weight: 500;marginTop:2px;font-size: 15px;">{{ couponInfo.left_name }}</p>
            </div>
          </div>
          <div class="coupon_right">
            <p class="coupon_name">{{ couponInfo.right_name }}</p>
            <p class="coupon_time">自领取后{{ couponInfo.expire_hours }}小时有效</p>
            <!-- <p class="coupon_time">自领取之日起{{ couponInfo.expire_days }}日有效</p> -->
          </div>
        </div>
        <div class="get_box">
          <div v-if="uid_show" class="tip">请输入手机号</div>
          <div v-if="uid_show" class="phone_box">
            <div class="area_num">
              <van-dropdown-menu>
                <van-dropdown-item v-model="area_num" :options="num_option" />
              </van-dropdown-menu>
            </div>
            <div style="border-right: 1px solid #999;height: 20px;"></div>
            <van-field v-model="mobile" placeholder="请输入注册手机号" />
          </div>
          <div>
            <van-button class="input__" round block color="linear-gradient(133deg, #F76262 0%, #EE2E2E 100%)" @click="draw">
              领取
            </van-button>
          </div>
        </div>
      </div>
      <div v-else class="nothingness">
        <img src="https://newoss.zhulong.com/forum/202306/14/15/1686728350641932.png" alt="">
        <p>{{ msg+'~' }}</p>
      </div>
    </div>

  </div>
</template>

<script>
import { getById, receive } from '@/api/ucenterCouponTwo.js'
import { getAgencyInfo } from '@/api/bbsCoupon.js'
import Cookies from 'js-cookie'
export default {
  name: '',

  data() {
    return {
      mobile: '',
      area_num: 86,
      num_option: [
        { text: '+86', value: 86 }
      ],
      query: {},
      couponInfo: {},
      money: '',
      short_name: '', // 机构ID
      my_title: null, // title
      my_description: null, // 关键词
      uid_show: false,

      msg: ''
    }
  },

  computed: {},

  created() {
    this.query = this.$route.query
    this.getMsg()
    this.getAgencyInfo()
    if (Cookies.get('uid')) {
      this.uid_show = false
    } else {
      this.uid_show = true
    }
  },

  mounted() {},

  methods: {
    goBack() {
      this.$router.go(-1)
    },
    // 获取来源
    getForm() {
      var url = document.URL
      var urlArr = url.split('?')[1].split('&')
      urlArr.forEach((i) => {
        var val = i.split('=')
        switch (val[0]) {
          case 'id':
            this.id = val[1]
            break
        }
      })
    },
    getMsg() {
      // const info = {
      //   id: this.id
      // }
      getById(this.query).then((res) => {
        if (res.errNo == -1) {
          this.msg = res.msg
        } else {
          this.couponInfo = res.result || {}
          this.money = this.couponInfo.discount_radio ? this.couponInfo.discount_radio / 10 + '折' : this.couponInfo.money + '元'
          console.log(this.money, ' this.money')
          console.log(res, '优惠券详情')
        }
        this.loading = false
      }).then(message => {
        this.getSeo()
      }).catch(() => {
        this.loading = false
      })
    },
    formatTel(tel) {
      return tel.replace(/\s/g, '').substring(0, 3) + '****' + tel.substr(tel.length - 4)
      // return phoneNum.
    },
    draw() {
      console.log(this.formatTel(this.mobile))
      // return
      const info = {
        coupon_id: this.query.id,
        mobile: this.mobile,
        // uid: Cookies.get('uid')
        uid: this.query.uid
      }
      receive(info).then(res => {
        console.log(res, '000000')
        if (res.errNo === 0) {
          this.$router.push({
            path: 'getSuccess',
            query: {
              mobile: this.formatTel(this.mobile),
              expire_days: this.couponInfo.expire_days,
              coupon_type_name: this.couponInfo.right_name,
              lesson_id: this.couponInfo.lesson_id,
              use_type: this.couponInfo.use_type,
              type_id: this.couponInfo.type_id,
              e_v_id: this.couponInfo.product_id || ''
            }
          })
        } else if (res.errNo == '10022') {
          this.$router.push({
            path: '/alreadyReceived',
            query: {
              mobile: this.formatTel(this.mobile),
              expire_days: this.couponInfo.expire_days,
              coupon_type_name: this.couponInfo.right_name,
              lesson_id: this.couponInfo.lesson_id,
              use_type: this.couponInfo.use_type,
              type_id: this.couponInfo.type_id,
              e_v_id: this.couponInfo.product_id || ''
            }
          })
        } else {
          this.$toast(res.msg || '领取失败')
        }
      })
    },
    // 获取机构名称
    getAgencyInfo() {
      getAgencyInfo().then(res => {
        this.short_name = res.result.name
      })
    },
    // seo 设置
    getSeo() {
      if (!this.couponInfo) return
      switch (this.couponInfo.use_type) {
        case 0:
          this.my_title = document.getElementsByTagName('title')[0]
          this.my_title.innerHTML = this.money + '训练营通用优惠券'
          this.my_description = document.getElementsByName('description')[0]
          this.my_description.content = this.short_name + '训练营，全场通用社群优惠券，名额有限，限时领取'
          break
        case 1:
          this.my_title = document.getElementsByTagName('title')[0]
          this.my_title.innerHTML = this.money + '精品课通用优惠券'
          this.my_description = document.getElementsByName('description')[0]
          this.my_description.content = this.short_name + '精品课，全场通用社群优惠券，名额有限，限时领取'
          break
        case 2:
          this.my_title = document.getElementsByTagName('title')[0]
          this.my_title.innerHTML = '1年VIP会员' + this.money + '立减优惠券'
          this.my_description = document.getElementsByName('description')[0]
          this.my_description.content = '立享' + this.short_name + 'VIP专栏专家讲座，还有更多权益，名额有限，限时领取'
          break
        case 3:
          this.my_title = document.getElementsByTagName('title')[0]
          this.my_title.innerHTML = '1年E会员' + this.money + '立减优惠券'
          this.my_description = document.getElementsByName('description')[0]
          this.my_description.content = '立享' + this.short_name + '精品资料免费下载，还有更多权益，名额有限，限时领取'
          break
        default:
          break
      }
    }
  }
}

</script>
<style lang='less' scoped>
p{
  margin: 0;
  padding: 0;
}
@font-face {
    font-family: "Impact";
    src: url('/assets/Impact.ttf');
    font-weight: normal;
    font-style: normal;
}
/deep/.van-dropdown-menu__bar{
  box-shadow: 0 0 0;
  height: 45px;
}
.header{
  width: 760px;
  padding: 0 10px;
  position: absolute;
  top:56px;
  color:#fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  font-size: 50px;
  .arrow_left{
      font-size: 64px;
    }
}
.coupon_box{
  width: 100%;
  position: relative;
  margin-top:-126px;
  img{
    width: 100%;
  }
  .coupon_left{
    position: absolute;
    // left:120px;
    width: 44%;
    height: 100%;
    line-height: 1;
    top:0px;
    font-size: 30px;
    color: #EE2E2E;
    letter-spacing: 1.33px;
    text-align: center;
    font-weight: 500;
    div{
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .num{
      font-family: "Impact" !important;
      font-size: 43px;
      color: #EE2E2E;
      text-align: left;
      font-weight: 900;
    }
    .top{
        font-size: 30px;
        .number{
          font-size: 86px;
        }
      }
      .danwei{
        font-size: 30px;
      }
  }
  .coupon_right{
    width: 58%;
    height: 100%;
    display: flex;
    flex-direction: column;
    // align-items: center;
    justify-content: center;
    position: absolute;
    right:0px;
    top:0px;
    font-size: 60px;
    color: #333333;
    letter-spacing: 1.33px;
    text-align: center;
    font-weight: 500;groupBooking
    text-align: left;
    .coupon_name{
      width: 65%;
      height:88px;
      line-height: 88px;
      display: flex;
      font-size: 30px;
      // flex-direction: column;
      // justify-content: center;
      font-family: PingFangSC-Medium;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
      font-weight: 500;
      margin-bottom:5px;
    }
    .coupon_time{
      margin-top:10px;
      text-align: left;
      font-size: 28px;
      color: #999999;
      letter-spacing: 0;
      // text-align: center;
      font-weight: 400;
    }
  }
}
.get_box{
  padding:0 80px;
  .tip{
    letter-spacing: 0;
    text-align: center;
    font-weight: 700;
    margin-bottom:23px;
    font-family: PingFang-SC-Bold;
    font-size: 40px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 700;
  }
}
.phone_box{
  height: 90px;
  padding:0 40px;
  background: #FFFFFF;
  border-radius: 90px;
  line-height: 90px;
  margin-bottom:60px;
  display: flex;
  align-items: center;
  .area_num{
    width: 320px;
    height: 48px;
    padding:0 60px 0 0;

    box-sizing: border-box;
    font-family: PingFangSC-Medium;
    font-size: 64px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
    // border-right: 1px solid #999999;
  }
}
.headerPage{
  // position: fixed;
  // top: 0;
  // left: 0;
  margin:  0 auto;
  min-height: 100vh;
  z-index: 1000;
  background: #F0F0F0;
}
.page_header{
    height: 80px;
    line-height: 80px;
    border-bottom: 1px solid #ddd;
    padding: 0 25px 0 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title{
        font-size: 68px;
        // font-weight: 600;
    }
    .arrow_left{
      width: 48px;
      height: 84px;
    }
    .more_icon{
      width: 84px;
      height: 60px;
      // margin-right: 80px;
      margin-right: 0px;
    }
}
.top{
  img{
    width: 100%;
    // height: 453px;
  }
}
.input__{
  height:90px;
  line-height: 90px;
  font-size: 32px;
  }

.nothingness{
  img{
    margin: 0 auto;
    display: block;
  }
  p{
    font-size: 28px;
    text-align: center;
    color: #999;
  }
}
</style>

